import { ApplicationConfig, importProvidersFrom, Inject, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { getAppConfigProvider } from '@rslweb/app-config';
//import { environment } from '../environments/environment';
import { authInterceptor } from '@rslweb/auth-data-access';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { provideHighcharts } from 'highcharts-angular';

declare global {
  interface Window {
    runtimeConfig: any;
  }
}

export const getApplicationConfig = (): ApplicationConfig => {
  const config = window.runtimeConfig;

  return {
    providers: [
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(appRoutes),
      provideHttpClient(
        withInterceptors([
          authInterceptor,
        ])
      ),
      getAppConfigProvider(config.environment),
      provideHighcharts(),

      importProvidersFrom(
        LoggerModule.forRoot({
          serverLoggingUrl: `${config.environment.apiUrl}logs`,
          level: config.environment.production ? NgxLoggerLevel.ERROR : NgxLoggerLevel.DEBUG,
          serverLogLevel: NgxLoggerLevel.DEBUG,
          disableConsoleLogging: config.environment.production
        })
      ),
    ],
  };
};
